var BlockView = require('views/block/base-block-view');
var LocaleService = require('services/locale-service');
var FeedbackService = require('services/feedback-service');
const DOMPurify = require('dompurify');

var PopoverView = BlockView.extend({
  autoRender: false,
  autoAttach: false,
  render: function () {
    var templateFunc = this.getTemplateFunction();

    if (typeof templateFunc === 'function') {
      var html = templateFunc(this.getTemplateData(), { allowProtoPropertiesByDefault: true });

      if (this.model.get('target') === '{{feedback_element}}') {
        if (FeedbackService.triggerElement) {
          this.target = FeedbackService.triggerElement;
        } else {
          console.warn('Tried to target a feedback element when no feedback is being rendered');
        }
      } else {
        this.target = $(this.model.get('target'));
      }

      if (this.target.data('bs.popover')) {
        //if there's already a popover, we need to remove it
        //can't use destroy because that removes the data after hide finishes and
        //we'll have already replaced it with the data for the new popover data by that point
        var popover = this.target.data('bs.popover');
        this.target.removeData('bs.popover');
        popover.hide();
      }

      this.target.popover({
        placement: this.model.get('placement'),
        trigger: 'manual',
        animation: true,
        html: true,
        template: html,
        container: '.' + this.parent.region,
        title: this.buildTitle(this.model.get('heading_level')),
        content: LocaleService.t(this.model.get('description')),
      });
      this.target.one('shown.bs.popover', () => {
        this.attach();
      });
      if (this.model.get('auto_open') !== false) {
        this.target.attr('aria-expanded', true);
        setTimeout(() => {
          this.target.popover('show');
        }, 1000);
      }
    }
  },
  attach: function () {
    var popoverId = DOMPurify.sanitize(this.target.attr('aria-describedby'));
    this.setElement($('#' + popoverId)[0], true);
    var self = this;
    var focusOnOpen = this.model.get('focus_on_open');
    if (focusOnOpen) {
      $('#' + popoverId).focus();
    }
    this.delegate('click', '[data-close]', function () {
      this.target.attr('aria-expanded', false);
      this.target.popover('hide');
      if (!self.model.get('complete_on_shown')) {
        self.readyToGo();
      }
    });

    return this.trigger('addedToDOM');
  },
  play: function () {
    if (this.model.get('complete_on_shown')) {
      this.readyToGo();
    }
  },
  buildTitle: function (heading_level) {
    let level = heading_level || 3;
    return `<button type="button" class="close" data-close="true" aria-label="Close">
    <span aria-hidden="true">&times;</span></button>
    <h${level} aria-level="${level}">${LocaleService.t(this.model.get('header'))}</h${level}>`;
  },
  dispose: function () {
    if (this.target.data('bs.popover')) {
      var popover = this.target.data('bs.popover');
      //don't need to hide - the element is about to be removed anyway
      //don't remove data if it's for a different popover
      if (popover.options.container === '.' + this.parent.region) {
        this.target.removeData('bs.popover');
      }
    }
    // focus the element which triggered the popover - accessiblity issue
    if (this.target.attr('tabindex')) {
      this.target.focus();
    } else {
      this.target.find('[tabindex=0]').first().focus();
    }

    //TODO: figure out if we need to do anything else here, such as clearing events
    BlockView.prototype.dispose.apply(this, arguments);
  },
});

module.exports = PopoverView;
